import React, { useCallback, useEffect, useState } from "react";
import TableContainer from "Common/TableContainer";
import { Loader } from "../../Common/Loader";
import { Pencil, Trash2, Plus } from "lucide-react";
import DeleteModal from "Common/DeleteModal";
import { ToastContainer } from "react-toastify";
import { Common } from "helpers/common";
import moment from "moment";
import { AddClass } from "./AddClass";
import { getClassList, deleteClass } from "helpers/backend_helper";
import { useClassStore } from "store/useClassStore";

function ClassList() {
  const [classes, setClasses] = useState<any[]>(useClassStore.getState().classes);
  const [filteredClasses, setFilteredClasses] = useState<any[]>(useClassStore.getState().classes);
  const [eventData, setEventData] = useState<any>();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [searchText, setSearchText] = useState('');
  const [show, setShow] = useState<boolean>(false);
  const [classData, setClassData] = useState<any>({});
  const uiHelper = new Common();

  // Delete Modal
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const deleteToggle = () => setDeleteModal(!deleteModal);

  useEffect(() => {
    document.body.classList.remove('overflow-hidden');
    console.log("Classes:", classes);
    console.log("Filtered Classes:", filteredClasses);
    setIsLoading(false);
    //loadClasses(false);
  }, []);



  // Delete Data
  const onClickDelete = (cell: any) => {
    setDeleteModal(true);
    if (cell.classId) {
      setEventData(cell);
    }
  };

  const handleDelete = async () => {
    if (eventData) {
      try {
        await deleteClass(eventData);
        setDeleteModal(false);
        uiHelper.showSuccessMessage("Class has been deleted successfully.");

        // remove the item and update list
        setClasses((prev) =>
          prev.filter((item) => item.classId !== eventData.classId)
        );
        setFilteredClasses((prev) =>
          prev.filter((item) => item.classId !== eventData.classId)
        );
      } catch (error) {
        console.error("Error deleting class:", error);
        uiHelper.showErrorMessage("Error deleting class");
      }
    }
  };

  const filterSearchData = (e: any) => {
    const searchText = e.target.value;
    setSearchText(searchText);

    if (searchText.length > 0) {
      const filteredData = classes.filter(
        (item) =>
          item.className.toLowerCase().includes(searchText.toLowerCase()) ||
          (item.description && item.description.toLowerCase().includes(searchText.toLowerCase()))
      );
      setFilteredClasses(filteredData);
    } else {
      setFilteredClasses(classes);
    }
  };

  const handleAddClass = () => {
    setClassData({});
    toggle();
  };

  const handleEdit = (data: any) => {
    setClassData(data);
    toggle();
  };

  const onSave = (result: any) => {
    console.log("Save result:", result);
    setClasses((prev) => updateClass(prev, result));
    setFilteredClasses((prev) => updateClass(prev, result));
    //loadClasses(true);
    toggle();
  };

useEffect(() => {
  console.log("Classes:", classes);
  useClassStore.getState().setClasses(classes);
}, [classes]);


  /// Helper function to handle update or add
  const updateClass = (prev: any[], result: any) => {
    const exists = prev.some((item) => item.classId === result.classId);
    return exists
      ? prev.map((item) =>
          item.classId === result.classId ? { ...item, ...result } : item
        )
      : [...prev, result];
  };



  const toggle = useCallback(() => {
    setShow(!show);
    if (show) {
      setClassData(null);
    }
  }, [show]);

  const columns = [
    {
      header: "Class Name",
      accessorKey: "className",
      enableColumnFilter: false,
      enableSorting: false,
    },
    {
      header: "Description",
      accessorKey: "description",
      enableColumnFilter: false,
      enableSorting: false,
      cell: ({ row }: any) => (
        <span>{row.original.description || '-'}</span>
      ),
    },
    {
      header: "Created On",
      accessorKey: "createdOn",
      enableColumnFilter: false,
      enableSorting: false,
      cell: ({ row }: any) => (
        <span>{moment(row.original.createdOn).format("MMM DD, YYYY")}</span>
      ),
    },
    {
      header: "Created By",
      accessorKey: "createdByName",
      enableColumnFilter: false,
      enableSorting: false,
    },
    {
      header: "Updated On",
      accessorKey: "updatedOn",
      enableColumnFilter: false,
      enableSorting: false,
      cell: ({ row }: any) => (
        <span>{row.original.updatedOn ? moment(row.original.updatedOn).format("MMM DD, YYYY") : '-'}</span>
      ),
    },  
    {
      header: "Updated By",
      accessorKey: "updatedByName",
      enableColumnFilter: false,
      enableSorting: false,
      cell: ({ row }: any) => (
        <span>{row.original.updatedByName || '-'}</span>
      ),
    },
    {
      header: "Actions",
      id: "actions",
      enableColumnFilter: false,
      enableSorting: false,
      cell: ({ row }: any) => {
        const classItem = row.original;
        return (
          <div className="flex items-center gap-2">
            <button
              type="button"
              className="inline-flex items-center justify-center w-8 h-8 text-blue-500 bg-blue-100 rounded hover:bg-blue-500 hover:text-white transition-colors duration-200"
              onClick={() => handleEdit(classItem)}
            >
              <Pencil className="size-4" />
            </button>
            <button
              type="button"
              className="inline-flex items-center justify-center w-8 h-8 text-red-500 bg-red-100 rounded hover:bg-red-500 hover:text-white transition-colors duration-200"
              onClick={() => onClickDelete(classItem)}
            >
              <Trash2 className="size-4" />
            </button>
          </div>
        );
      },
    },
  ];

  return (
    <React.Fragment>
      <ToastContainer closeButton={false} limit={1} />
      <div className="grid grid-cols-1 gap-x-5 xl:grid-cols-12" style={{ marginTop: 15 }}>
        <div className="xl:col-span-12">
          <div className="card" id="classTable">

            <div className="flex items-center justify-between border-y border-dashed" style={{ padding: 10 }}>
              <div className="flex items-center gap-2 shrink-0">
                <h6 className="text-15">Filter </h6>
                <input
                  type="text"
                  className="w-full form-input  focus:outline-none focus:border-none focus:ring focus:ring-custom-100"
                  placeholder="Class Name or Description"
                  value={searchText}
                  onChange={filterSearchData}
                />

                <div className="flex justify-end shrink-0">
                  <button
                    type="button"
                    className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                    onClick={handleAddClass}
                    style={{ marginLeft: "auto" }}
                  >
                    <Plus className="inline-block size-4" />{" "}
                    <span className="align-middle">Add Class</span>
                  </button>
                </div>
              </div>
            </div>


            {isLoading ? (
              <Loader />
            ) : (
              <TableContainer
                columns={columns}
                data={filteredClasses}
                isPagination={true}
                customPageSize={15}
                divclassName="overflow-x-auto"
                tableclassName="w-full whitespace-nowrap"
                theadclassName="ltr:text-left rtl:text-right bg-custom-200 dark:bg-zink-600"
                thclassName="px-2.5 py-1.5 font-semibold border-b border-slate-200 dark:border-zink-500"
                tdclassName="px-2.5 py-1.0 border-y border-slate-200 dark:border-zink-500"
                trclassName="even:bg-custom-50  dark:odd:bg-zink-700 dark:even:bg-zink-600"
                PaginationClassName="flex flex-col items-center gap-4 px-4 mt-3 md:flex-row"
              />
            )}

          </div>
        </div>
      </div>


      {classData ? (
        <AddClass 
          show={show} 
          onHide={toggle} 
          data={classData} 
          onSave={onSave}
        />) : (<></>)}

      {/* Delete Modal */}
      <DeleteModal
        show={deleteModal}
        onHide={deleteToggle}
        onDelete={handleDelete}
      />
    </React.Fragment>
  );
}

export default ClassList;

